<script setup lang="ts">
import {CourseComment} from "@/types";
import {TimeFormatter} from "@/utils/common.ts";
import {ElMessageBox, ElNotification} from "element-plus";
import {CourseService} from "@/api/api.ts";

const props = defineProps<{
  comment: CourseComment
}>()

const emit = defineEmits(['onReply'])

const onReply = () => {
  emit("onReply", props.comment)
}

const onDel = async () => {
  try {
    await ElMessageBox.confirm(
        '确认删除该回复内容吗',
        '注意',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
    )
    const res = await CourseService.delCommentReply({
      id: props.comment.id,
      course_id: props.comment.course_id,
    })
    if (res.data.code === 200) {
      ElNotification.success({
        message: res.data.msg,
      })
      props.comment.reply = ''
    } else {
      ElNotification.error({
        message: res.data.msg,
      })
    }
  } catch (err) {
    console.warn(err)
  }
}

const showWarning = () => {
  ElNotification.info({
    message: '暂不支持PC端点赞,请使用移动端~',
  })
}
</script>

<template>
  <div class="mx-2rem">
    <div class="flex gap-16px mt-1rem">
      <el-avatar :size="32" :src="comment.head_img" />
      <div class="flex-1">
        <div class="text-0.875rem text-[rgba(0,0,0,0.651)] font-bold">
          {{ comment.user_name }}
        </div>
        <div class="flex items-center mt-.25rem">
          <div class="text-0.875rem text-[rgba(0,0,0,0.651)]">总体评价</div>
          <el-rate v-model="comment.grade" disabled class="ml-.25rem"/>
        </div>
        <div class="text-0.875rem text-[rgba(0,0,0,0.651)]">
          {{ comment.content }}
        </div>
        <div class="mt-1rem">
          <el-image
              style="width: 7.5rem; height: 7.5rem"
              :src="item"
              :zoom-rate="1.2"
              :max-scale="7"
              :min-scale="0.2"
              :preview-src-list="comment.images"
              :initial-index="index"
              fit="cover"
              class="mr-1rem rounded"
              v-for="(item, index) in comment.images"
          />
        </div>
      </div>
      <div class="flex flex-col items-end">
        <el-image :src="comment.thumb_image" class="w-8.75rem h-5rem rounded"></el-image>
        <div class="mt-.75rem text-[rgba(0,0,0,0.251)] text-.875rem">{{ `来自：${comment.title}`}}</div>
      </div>
    </div>
    <div class="bg-#f5f5f5 rounded-.5rem py-.75rem px-1rem w-56rem ml-48px mt-1rem flex" v-if="comment.reply">
      <div class="flex-1 mr-1rem">
        回复：{{ comment.reply }}
      </div>
      <div class="flex gap-.25rem items-center cursor-pointer" @click="onDel">
        <img src="@/assets/image/icon/icon-delete.png" class="w-1rem h-1rem" alt="icon-reply" />
        <div class="text-.75em text-[rgba(0,0,0,0.251)] mt-2px">删除</div>
      </div>
    </div>
    <div class="ml-48px mt-.75rem flex">
      <div class="text-.85em text-[rgba(0,0,0,0.251)] mr-4rem">{{ TimeFormatter.formatTime(comment.create_time * 1000) }}</div>
      <div class="flex gap-.25rem mr-2rem items-center cursor-pointer" @click="showWarning">
        <img src="@/assets/image/icon/icon-praise.png" class="w-1rem h-1rem"  alt="icon-praise"/>
        <div class="text-.75em text-[rgba(0,0,0,0.251)] mt-2px">{{ comment.like_num }}</div>
      </div>
      <div class="flex gap-.25rem items-center cursor-pointer" @click="onReply" v-if="!comment.reply">
        <img src="@/assets/image/icon/icon-reply.png" class="w-1rem h-1rem" alt="icon-reply" />
        <div class="text-.75em text-[rgba(0,0,0,0.251)] mt-2px">回复</div>
      </div>
    </div>
    <div class="bg-#e9e9e9 h-1px mt-1rem"></div>
  </div>
</template>

<style scoped>

</style>